import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-savingsapprovals',
  templateUrl: './savingsapprovals.component.html',
  styleUrls: ['./savingsapprovals.component.css']
})
export class SavingsapprovalsComponent implements OnInit {
  @Input('loan_approvals') loan_approvals: any;
  @Output() addNewApprovalLevel = new EventEmitter();
  @Output() deleteApprovalLevel = new EventEmitter();
  @Output() updateApprovalLevel = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  newLevel() {
    this.addNewApprovalLevel.emit();
  }
  deleteLevel(level) {
    this.deleteApprovalLevel.emit({level:level});
  }
  update(level) {
    this.updateApprovalLevel.emit({level:level});
  }
}
